export function buildKioskQueryParam(waiverName: string | null | undefined): string {
  const params = new URLSearchParams({ kiosk: 'true' })
  /** Used when we wish to force the display of one particular waiver and avoid user selection */
  if (waiverName) params.set('waiverName', waiverName)
  return params.toString()
}

/** Filter waiver content by name or id (case-insensitive). Returns original array if no match. */
export function filterWaiverContentByName<T extends { id: string; name: string }>(
  waiverContent: T[],
  waiverName: string | null | undefined
): T[] {
  if (!waiverName || waiverContent.length <= 1) return waiverContent
  const waiverNameLower = waiverName.toLowerCase()
  const match = waiverContent.filter((w) => w.id === waiverName || w.name.toLowerCase() === waiverNameLower)
  return match.length > 0 ? match : waiverContent
}
